import { faFileCheck } from '@fortawesome/pro-light-svg-icons'

import { Box, DashboardModule } from '@domain-group/suit-theme'

import useCurrentUser from '@hooks/useCurrentUser'
import useReduxAction from '@hooks/useReduxAction'

import type {
  ArtworkReviewPendingOrderModel, ArtworkReviewRequestOptions, UserModel,
} from '@models/types'

import { ModuleState } from '@redux/modules/module'

import { sanitizeFilters } from '@functions/entity'

import ReviewedArtworkListItem from './ReviewedArtworkListItem'

export const icon = faFileCheck

type ConfigOptionsParams = {
  currentUser?: UserModel,
  isAgent?: boolean,
  isCampaignManager?: boolean,
}

export const configOptions = (params: ConfigOptionsParams) => {
  const { currentUser, isAgent, isCampaignManager } = params

  const options = {
    priority_status: {
      component: 'select',
      hidden: isAgent || isCampaignManager,
      key: 'priority_reviewed_artworks_by_user_id',
      label: 'Priority Status',
      optionKey: 'queryParams',
      values: [
        { key: 'all', label: 'All' },
        { key: currentUser?.id, label: 'Priority Only' },
      ],
    },
  }

  const filteredOptions = Object.fromEntries(
    Object.entries(options).filter(([key, value]) => !value.hidden),
  )

  return filteredOptions
}

interface ReviewedArtworksProps {
  customOptions: {
    queryParams?: {

    },
    requestOptions: ArtworkReviewRequestOptions,
  },
  editing: boolean,
}

const ReviewedArtworks = (props: ReviewedArtworksProps) => {
  const { customOptions: { queryParams, requestOptions }, editing } = props

  // @ts-expect-error TS2345
  const filters = sanitizeFilters(queryParams)
  // @ts-expect-error TS2339
  const { priority_reviewed_artworks_by_user_id: selectedPriorityUserId } = filters

  const { isAgent } = useCurrentUser()

  const { loading: isLoading, data: artworkReviews } = useReduxAction(
    'artworkReviews',
    'loadPendingOrders',
    {
      ...filters,
      include_artwork_review_priority_campaign_user_ids: !isAgent,
      ...requestOptions,
    },
    [JSON.stringify(queryParams)],
    { shouldPerformFn: ({ loading }: ModuleState) => !loading, skipLoadedForKeysCheck: true },
  )

  // @ts-expect-error TS2339
  if (!isLoading && !artworkReviews?.length) return null

  return (
    <DashboardModule
      editing={editing}
      loading={isLoading}
      title="Reviewed Artworks"
    >
      {/*
       // @ts-expect-error TS2339 */}
      {!isLoading && !!artworkReviews?.length && (
        // @ts-expect-error TS2322
        <DashboardModule.ScrollableSection maxHeight={400}>
          <Box flexDirection="column">
            {/*
             // @ts-expect-error TS2339 */}
            {artworkReviews.map((artworkReview: ArtworkReviewPendingOrderModel) => (
              <ReviewedArtworkListItem
                artworkReview={artworkReview}
                filteringPriorityOnly={!!selectedPriorityUserId}
                key={artworkReview.id}
              />
            ))}
          </Box>
        </DashboardModule.ScrollableSection>
      )}
    </DashboardModule>
  )
}

export default ReviewedArtworks
